module.exports = __webpack_public_path__ + "img/huawei.a3b775fe.png";